import React from 'react';
import { ProgressBar } from '../ProgressBar/ProgressBar';
import { CircularProgress } from '../CircularProgress/CircularProgress';
import { useActiveLeaderboardEvent } from '../../hooks/useActiveLeaderboardEvent';
import './ProgressOverview.scss';

type ViewType = 'bars' | 'circles';

interface ProgressData {
  label: string;
  value: number;
  max: number;
}

interface ProgressOverviewProps {
  data?: ProgressData[];
  viewType?: ViewType;
}

const ProgressOverview: React.FC<ProgressOverviewProps> = ({ data, viewType = 'bars' }) => {
  const { activeEvent } = useActiveLeaderboardEvent();

  const defaultData: ProgressData[] = activeEvent
    ? [
      { label: 'Total Hours', value: 0, max: activeEvent.milestone },
      { label: 'Total Reviews', value: 0, max: activeEvent.reviewMilestone },
    ]
    : [
      { label: 'Total Hours', value: 0, max: 1000 },
      { label: 'Total Reviews', value: 0, max: 1000 },
    ];

  const displayData = data || defaultData;
  return (
    <div className="progress-section-container">
      <div className="progress-section-title">Overview</div>

      {viewType === 'bars' ? (
        <div className="progress-bars">
          {displayData.map((item, index) => (
            <ProgressBar key={index} label={item.label} value={item.value} max={item.max} />
          ))}
        </div>
      ) : (
        <div className="progress-circles">
          {displayData.map((item, index) => (
            <CircularProgress key={index} label={item.label} value={item.value} max={item.max} />
          ))}
        </div>
      )}
    </div>
  );
};

export { ProgressOverview };
